import {
  EMAIL_SUBSCRIPTION_FETCH_SUCCESS,
  DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS
} from '../constant/actionType';

const initialState = {
  csv: null,
  subscriptions: []
};

const emailSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_SUBSCRIPTION_FETCH_SUCCESS:
      return {
        ...state,
        subscriptions: action.data
      };

    case DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        csv: action.data
      };

    default:
      return state;
  }
};

export default emailSubscriptionReducer;
